import * as queryString from 'query-string';
import LocationPathHelper from './location_path_helper';
export var getUrlParamValue = function (key) {
    var urlSearch = LocationPathHelper.getWindowLocationSearch();
    var searchParams = queryString.parse(urlSearch);
    return (searchParams === null || searchParams === void 0 ? void 0 : searchParams[key]) || '';
};
export var getAllUrlParamValues = function () {
    var urlSearch = LocationPathHelper.getWindowLocationSearch();
    return queryString.parse(urlSearch) || {};
};
// note: current url search param can be retrieved using window.location.search
export var appendParamToSearchParam = function (searchParam, key, value) {
    var paramsString = new URLSearchParams(searchParam);
    paramsString.append(key, value);
    return "?" + paramsString.toString();
};
